import produce from "immer";
import {
  FETCH_SETTINGS,
  FETCH_SETTINGS_SUCCESS,
  FETCH_SETTINGS_FAILURE,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_SUCCESS,
  GET_VIEW_DATA_FAILURE,
  //
  ADD_SETTINGS,
  ADD_SETTINGS_SUCCESS,
  ADD_SETTINGS_FAILURE,
  //
  EDIT_SETTINGS,
  EDIT_SETTINGS_SUCCESS,
  EDIT_SETTINGS_FAILURE,
  //
  DELETE_SETTINGS,
  DELETE_SETTINGS_SUCCESS,
  DELETE_SETTINGS_FAILURE,
} from "./constants";

export const initialState = {
  isFetchingSettings: false,
  Settings: [],
  // Add / Edit
  isSubmitting: false,
  // View
  isFetching: false,
  currentSettings: {},
  // Delete
  isDeleting: false,
};

const ReviewSettingsReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // List
      case FETCH_SETTINGS:
        draft.isFetchingSettings = true;
        draft.currentSettings = {};
        draft.Settings = [];
        break;
      case FETCH_SETTINGS_SUCCESS:
        draft.isFetchingSettings = false;
        draft.Settings = action.payload;
        break;
      case FETCH_SETTINGS_FAILURE:
        draft.isFetchingSettings = false;
        draft.Settings = [];
        break;
      // View
      case GET_VIEW_DATA:
        draft.isFetching = true;
        draft.currentSettings = {};
        break;
      case GET_VIEW_DATA_SUCCESS:
        draft.isFetching = false;
        draft.currentSettings = action.payload;
        break;
      case GET_VIEW_DATA_FAILURE:
        draft.isFetching = false;
        break;
      // Add
      case ADD_SETTINGS:
        draft.isSubmitting = true;
        break;
      case ADD_SETTINGS_SUCCESS:
        draft.isSubmitting = false;
        break;
      case ADD_SETTINGS_FAILURE:
        draft.isSubmitting = false;
        break;
      // Edit
      case EDIT_SETTINGS:
        draft.isSubmitting = true;
        break;
      case EDIT_SETTINGS_SUCCESS:
        draft.isSubmitting = false;
        break;
      case EDIT_SETTINGS_FAILURE:
        draft.isSubmitting = false;
        break;
      // Delete
      case DELETE_SETTINGS:
        draft.isDeleting = true;
        break;
      case DELETE_SETTINGS_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_SETTINGS_FAILURE:
        draft.isDeleting = false;
        break;

      default:
        return state;
    }
  });

export default ReviewSettingsReducer;
